import * as debug from '@gitbook/slate-debug';

import Change, { ChangeFlags } from '../models/change';
import Data, { DataCreateProps } from '../models/data';
import Operation from '../models/operation';
import Value from '../models/value';

/*
 * Changes.
 */

const Changes = {};

/*
 * Set data on the value.
 */
Changes.setValueData = (
    change: Change,
    data: DataCreateProps,
    options: ChangeFlags = {}
) => {
    data = Data.create(data);
    const { value } = change;

    change.applyOperation(
        Operation.create({
            type: 'set_value_data',
            data,
            previousData: value.data
        }),
        options
    );
};

/*
 * Set `properties` on the value.
 */
Changes.setValue = (change, properties, options = {}) => {
    properties = Value.createProperties(properties);
    const { value } = change;

    debug.deprecate(
        'slate@3.3.0',
        "change.setValue is deprecated as it doesn't support realtime collaboration, use setValueData instead."
    );

    change.applyOperation(
        Operation.create({
            type: 'set_value',
            properties,
            value
        }),
        options
    );
};

export default Changes;
